module.exports = __webpack_public_path__ + "img/cartao_discover.e65466a2.png";